<template>
  <div class="createdButton" @click="onCreated()">{{value}}</div>
</template>

<script>
export default {
  props:['value'],
  created() {},
  methods: {
    onCreated() {
      this.$emit("onCreated");
    },
  },
};
</script>

<style scoped lang="scss">
.createdButton {
  display: inline-block;
  margin-left: 20px;
  width: 186px;
  height: 49px;
  background: #28262C;
  border-radius: 10px;
  font-size: 16px;
  line-height: 50px;
  text-align: center;
  color: #DED094;
  cursor: pointer;
  &:hover{
    background:#d8b656b8;
    color: #000;
  }
}    
</style>
